var exports = {
  "Z": "x2b2fbebb--7ada42--layout",
};

module.exports = exports;
